import {
  IsDate,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsArray,
  ValidateNested,
} from "class-validator";
import { Type } from "class-transformer";

import {
  IAdapterAssignmentAction,
  IAdapterAssignmentActionEntity,
} from "./adapter-assignment-action.interface";
import { QueryDto } from "../query";

export class AdapterAssignmentActionEntityDto
  implements IAdapterAssignmentActionEntity
{
  @IsNotEmpty()
  entity_id: string;

  @IsOptional()
  @IsDate()
  start_date?: Date;

  @IsOptional()
  @IsNumber()
  hours?: number;
}

export class AdapterAssignmentActionDto implements IAdapterAssignmentAction {
  @IsNotEmpty()
  folder_id: string;

  @IsOptional()
  @IsDate()
  start_date?: Date;

  // @IsOptional()
  // @IsNumber()
  // hours?: number;

  @IsOptional()
  availability_header_id?: string;

  // @IsNotEmpty()
  // entity_ids: string[]; //operation id

  @IsNotEmpty()
  @IsArray()
  @ValidateNested()
  @Type(() => AdapterAssignmentActionEntityDto)
  entities: AdapterAssignmentActionEntityDto[];

  @IsOptional()
  @ValidateNested()
  @Type(() => QueryDto)
  query?: QueryDto;

  @IsOptional()
  auto_post?: boolean;
}
